import {useAtom} from "jotai";
import {ConnectionAtom, fixMetlUrl, type MetlConnectionProperties} from "./MetlConnectionProperties.ts";
import {useFieldSetter} from "../../util/setter/FieldSetter.ts";
import Styles from "./Styles.module.scss"
import type {Setter} from "../../util/setter/Setter.ts";
import {Field} from "@matillion/component-library";
import {type ChangeEvent, useState} from "react";
import {MetlConnectionTest} from "./MetlConnectionTest.tsx";

import {checkScheme, desiredUrl} from "../../metl-api/util/SchemeCheck.ts";

interface OptionsProps {
    options: MetlConnectionProperties["options"]
    setOptions: Setter<MetlConnectionProperties["options"]>
}
function ConnectionOptionsWidget({options, setOptions}: OptionsProps) {
    const [open, setOpen] = useState(false)
    const [ retries, setRetries ] = useFieldSetter(options, setOptions, "retry")
    const [ retryDelay, setRetryDelay ] = useFieldSetter(options, setOptions, "retryDelay")
    const [ rateLimit, setRateLimit ] = useFieldSetter(options, setOptions, "rateLimit")
    if(!open) {
        return <div>
            <h3 onClick={() => setOpen(true)}>Connection Options X</h3>
        </div>
    }
    return <div>
        <h3 onClick={() => setOpen(false)}>Connection Options O</h3>
        <Field title="Retries" type="number" value={retries} onChange={(e: ChangeEvent<HTMLInputElement>) => setRetries(e.target.valueAsNumber)} />
        <Field title="Retry Delay" type="number" value={retryDelay} onChange={(e: ChangeEvent<HTMLInputElement>) => setRetryDelay(e.target.valueAsNumber)} />
        <Field title="Rate Limit" type="number"
               description="Maximum number of requests per second"
               value={rateLimit} onChange={(e: ChangeEvent<HTMLInputElement>) => setRateLimit(e.target.valueAsNumber)} />
    </div>
}

function MetlConnectionSubtext({url}: {url: string}) {
    const [validScheme, desiredScheme, currentScheme] = checkScheme(url)
    if(url.startsWith("http://") || url.startsWith("https://")) {
        const fixedUrl = fixMetlUrl(url)
        if(!validScheme) {
            return <>
                <div className={Styles.Connection}>Connecting to: {fixedUrl}</div>
                <div className={Styles.Cross}>
                    <p>This looks to be a {currentScheme} to {desiredScheme} connection, please change your current protocol.</p>
                    <a href={desiredUrl(desiredScheme)}>Click Here</a>
                </div>
            </>
        }
        return <div className={Styles.Connection}>Connecting to: {fixedUrl}</div>
    }
    return <div className={Styles.Connection}>Please put your Matillion ETL URL here, in the format https://matillion-url/</div>
}

export function MetlConnectionWidget() {
    const [connection, setConnection] = useAtom(ConnectionAtom)
    const [auth, setAuth] = useFieldSetter(connection, setConnection, "auth")
    const [baseUrl, setBaseUrl] = useFieldSetter(connection, setConnection, "baseUrl")
    const [username, setUsername] = useFieldSetter(auth, setAuth, "username")
    const [password, setPassword] = useFieldSetter(auth, setAuth, "password")
    const [options, setOptions] = useFieldSetter(connection, setConnection, "options")
    return <div className={Styles.Form}>
        <div className={Styles.Row}>
            <label>Base URL</label>
            <input value={baseUrl} onChange={(e) => setBaseUrl(e.target.value)} />
        </div>
        <MetlConnectionSubtext url={baseUrl} />
        <div className={Styles.Row}>
            <label>Username</label>
            <input value={username} onChange={(e) => setUsername(e.target.value)} />
        </div>
        <div className={Styles.Row}>
            <label>Password</label>
            <input value={password} type="password" onChange={(e) => setPassword(e.target.value)} />
        </div>
        <MetlConnectionTest />
        <ConnectionOptionsWidget options={options} setOptions={setOptions} />
        <div>
            <p>
                Welcome to the Matillion METL Upgrade Analysis Tool. This is a proof of concept tool to help analyse your
                METL environment and provide insights which help us to help you to upgrade from METL to DPC.
            </p>

            <p>
                This tool connects to your METL instance using the METL REST API, and is entirely contained within the
                browser. We do not store any of your data or transfer it out of your browser, except on the Upload step
                where the tool will generate an aggregated report, which you can review before it is uploaded.
            </p>
        </div>
    </div>
}